<template>
    <b-modal id="modal-change-kilometer-package"
             hide-footer
             centered
             v-model="isVisible"
             :title="$t('cdb.changeMileage.title')"
    >
        <div class="row">
            <div class="col-12">
                <div class="alert alert-info">
                    <data-entry-column :full-width="true" :title="$t('cdb.changeMileage.currentPrice')" :value="getPrice"></data-entry-column>
                    <data-entry-column :full-width="true" :title="$t('cdb.changeMileage.currentMileage')">
                        <template v-slot:value>
                            <span v-html="getCurrentMileage"></span>
                        </template>
                    </data-entry-column>
                </div>
                
                <div v-if="isDiscountedPrice">
                    <p>{{ $t('cdb.changeMileage.discount.warning') }}</p>
                </div>

                <div class="form-group mt-5 mb-3" v-if="subscription">
                    <b-form-select v-model="selectedMileage" class="mb-3">
                        <b-form-select-option :value="null" disabled="">{{ $t('cdb.changeMileage.selectNewMileage') }}</b-form-select-option>
                        <b-form-select-option
                            v-for="mileage in mileages"
                            :key="mileage.price"
                            v-if="mileage.mileage !== subscription.price_plan.mileage"
                            :value="mileage.mileage"
                        >
                            {{ $n(mileage.mileage, 'number') }} {{ $t('pds.buy_box.mileage_per_month') }}
                            <span v-if="showPriceWithoutTaxes">
                                {{ formatPrice(mileage.price_without_tax) }}
                            </span>
                            <span v-else>
                                {{ formatPrice(mileage.price) }}
                            </span>
                        </b-form-select-option>
                    </b-form-select>
                </div>
                <small v-if="selectedMileage">
                    <b-form-checkbox
                        v-model="checked"
                        :value="true"
                        :unchecked-value="false"
                    >
                        <span v-html="legalText"></span>
                    </b-form-checkbox>
                </small>
            </div>
        </div>
        <div class="row mt-3 d-flex justify-content-end">
            <button type="button" class="btn btn-secondary mr-3" @click="abort">{{ $t('cdb.subscriptions.close') }}</button>
            <button type="button" class="btn btn-primary mr-3" @click="submit" v-if="selectedMileage && checked && !isLoading">{{ $t('cdb.changeMileage.submit') }}</button>
            <button type="button" class="btn btn-primary mr-3" v-if="(!selectedMileage || !checked) && !isLoading">{{ $t('cdb.changeMileage.submit') }}</button>
            <button type="button" class="btn btn-primary mr-3" disabled v-if="isLoading">{{ $t('cdb.subscriptions.loading') }}</button>
        </div>
    </b-modal>
</template>

<script>
import { EventBus } from '../../event-bus';
import {
    BFormRadio, BModal, BFormRadioGroup, BFormCheckbox, BFormSelectOption,
    BFormSelect, BLink
} from 'bootstrap-vue';
import DataEntryColumn from "../atoms/DataEntryColumn.vue";
import moment from 'moment';

export default {
    name: 'ModalChangeKilometerPackage',
    components: {
        DataEntryColumn,
        BModal,
        BFormRadioGroup,
        BFormSelect, BFormSelectOption,
        BFormRadio,
        BFormCheckbox,
        BLink
    },
    data() {
        return {
            isVisible: false,
            isLoading: false,
            subscription: null,
            selectedMileage: null,
            duration: null,
            checked: false,
            mileages: [],
            vehicle: null,
            showPriceWithoutTaxes: this.$root.whitelabel.setting('show_price_without_taxes')
        }
    },
    mounted() {
        EventBus.$on('init-change-kilometer-package', this.getData);
    },
    methods: {
        getData(data) {
            this.isVisible = true
            this.subscription = data.subscription
            this.vehicle = this.subscription.vehicle
        },
        buildMileageArray() {
            let mileages = this.vehicle.price_plans.filter(mileage => {
                return mileage.minimum_duration == this.subscription.price_plan.duration
            })
            mileages.sort((a, b) =>  a.mileage - b.mileage)
            return mileages
        },
        submit() {
            this.isLoading = true
            this.$axios.put('api/v1/dashboard/update_subscriptions_mileage', {
                mileage: this.selectedMileage,
                subscription_uuid: this.subscription.uuid,
                price: this.getNewPriceForApi
            }).then(response => {
                if(response.data){
                    this.isLoading = false
                    this.selectedMileage = null
                    this.isSubmitting = false
                    this.isVisible = false
                    EventBus.$emit('cdb-reload-subscriptions', null);
                } else {
                    this.isLoading = false
                    this.error = true
                }
            }).catch(error => {
                this.isSubmitting = false
                this.error = true
            });
        },
        abort(){
            this.isVisible = false
        },
        formatPrice(price) {
            return this.$root.whitelabel.getFormatetPrice(price)
        }
    },
    computed: {
        getPrice(){
            if(this.subscription) {
                const price = this.showPriceWithoutTaxes ? this.subscription.price_plan.price_without_tax : this.subscription.price_plan.price
                return `${this.$root.whitelabel.getFormatetPrice(price)}`
            }

            return ''
        },
        getCurrentMileage(){
            return this.subscription ? `${this.$n(this.subscription.price_plan.mileage, 'number')} ${this.$t('pds.buy_box.mileage_per_month')}` : ''
        },
        isDiscountedPrice(){
            return this.subscription.price_plan.isDiscounted
        },
        getNewPriceForApi(){
            const selectedMileage = this.mileages.find(mileage => mileage.mileage === this.selectedMileage)
            const price = selectedMileage.price

            return price
        },
        getNewPrice(){
            const selectedMileage = this.mileages.find(mileage => mileage.mileage === this.selectedMileage)
            const price = this.showPriceWithoutTaxes ? selectedMileage.price_without_tax : selectedMileage.price
            return price
        },
        getBeginningOfNextPeriodDate() {
            const started = moment.unix(this.subscription.timestamps.started_at)
            const today = moment()
            const differenceInMonths = today.diff(started, 'months') + 1
            return this.$d(moment(started).add(differenceInMonths, 'M').toDate(), 'short')
        },
        isMarketplaceOwner() {
            if(this.subscription.subsidiary_uuid === this.$root.whitelabel.sub_id())
                return true
            else
                return false
        },
        legalText() {
            if(this.$root.whitelabel.setting('type') == 'marketplace' && !this.isMarketplaceOwner){
                return this.$t('cdb.changeMileage.legalText.forWlMp', {
                    ownerGtc: `<a target="_blank" href=${this.$getUrl('content-page', { path: 'agb' })}>${this.$t('cdb.changeMileage.mpOwnerGtc')}</a>`,                    
                    participantGtc: `<a target="_blank" href=${this.$root.whitelabel.setting('customer_agb_file_' + this.subscription.subsidiary_uuid)}>${this.$t('cdb.changeMileage.mpParticipantGtc', {mp_participant: this.subscription.subsidiary_name})}</a>`,
                    privacy: `<a target="_blank" href=${this.$getUrl('content-page', { path: 'datenschutz' })}>${this.$t('cdb.changeMileage.privacy')}</a>`,
                    beginningOfNextPeriod: this.getBeginningOfNextPeriodDate,
                    newPrice: this.$root.whitelabel.getFormatetPrice(this.getNewPrice)
                })
            } else {
                return this.$t('cdb.changeMileage.legalText', {
                    partnerGtc: `<a target="_blank" href=#/c/agb>${this.$t('cdb.changeMileage.partnerGtc')}</a>`,
                    privacy: `<a target="_blank" href=#/c/datenschutz>${this.$t('cdb.changeMileage.privacy')}</a>`,
                    beginningOfNextPeriod: this.getBeginningOfNextPeriodDate,
                    newPrice: this.$root.whitelabel.getFormatetPrice(this.getNewPrice)
                })
            }
        }
    },
    watch: {
        subscription: function (val) {
            if(this.subscription !== null){
                this.mileages = this.buildMileageArray()
            }
        }
    }
}
</script>
